import axios from "axios";
import { uiRequestInterceptor } from "@/interceptors/ui-request.interceptor";
import { uiResponseInterceptor } from "@/interceptors/ui-response.interceptor";
import { jwtInterceptor } from "@/interceptors/jwt.interceptor";
import { sessionRefreshInterceptor } from "@/interceptors/session-refresh.interceptor";
import { falconSessionInterceptor } from "@/interceptors/falcon-session.interceptor";
import { errorResponseToastInterceptor } from "@/interceptors/error-response-toast.interceptor";
import { i18nInterceptor } from "@/interceptors/i18n.interceptor";
import axiosHttpClient from "@/axios-http-client";

const axiosProxyHttpClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_BASE_URL}/proxy`
});

axiosProxyHttpClient.interceptors.request.use(uiRequestInterceptor.onFulfilled);
axiosProxyHttpClient.interceptors.request.use(jwtInterceptor.onFulfilled);
axiosProxyHttpClient.interceptors.request.use(
  falconSessionInterceptor.onFulfilled
);
axiosHttpClient.interceptors.request.use(i18nInterceptor.onFulfilled);

axiosProxyHttpClient.interceptors.response.use(
  uiResponseInterceptor.onFulfilled,
  uiResponseInterceptor.onRejected
);
axiosProxyHttpClient.interceptors.response.use(
  undefined,
  sessionRefreshInterceptor.onRejected
);
axiosProxyHttpClient.interceptors.response.use(
  undefined,
  errorResponseToastInterceptor.onRejected
);

export default axiosProxyHttpClient;
